// extracted by mini-css-extract-plugin
export default {"container":"qrscanner-input_container__yIkaX"};